<template>
  <div class="page-home box-card">
    <div class="box-card-header">
      <div class="right">
        <span class="btn kg-btn2" @click="$router.push({ name: 'publicDeposit' })">
          <I18Lang id="index5" defaultText="入金" />
        </span>
        <span class="btn kg-btn2" @click="$router.push({ name: 'publicWithdrawal' })">
          <I18Lang id="index6" defaultText="出金" />
        </span>
        <span class="btn kg-btn1" @click="$router.push({ name: 'transfer' })">
          <I18Lang id="index7" defaultText="转账" />
        </span>
        <i @click="refresh" class="refresh kg-refresh"></i>
      </div>
    </div>
    <div class="box-card-content">

      <div class="statistic-main">
        <div class="statistic-wallet">
          <div class="title">&ensp;&ensp;&ensp;{{ $t('usermoney14') }}&ensp;&ensp;&ensp;&ensp; &ensp;&ensp;&ensp;</div>
          <div class="name">{{ $t('my61') }} </div>
          <div class="num">{{ accountInfo.wallet_balance }}</div>
        </div>
        <div class="statistic-cash-account">
          <div class="title">{{ $t('my8') }} &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</div>
          <div class="name">{{ $t('index9') }} </div>
          <div class="num">{{ accountInfo.cash_balance }}</div>
        </div>
      </div>
    </div>

    <div class="box-card-content statistic-nums">
      <div class="statistic-item">
        <div class="icon"><i class="icon-user"></i></div>
        <div class="statistic-item-info">
          <span class="text">{{ $t('promotionTeamCount') }}</span>
          <span class="num">{{ promotionStats.team_count || 0 }}</span>
        </div>
      </div>
      <div class="statistic-item">
        <div class="icon"><i class="icon-invite"></i></div>
        <div class="statistic-item-info">
          <span class="text">{{ $t('promotionDirectValidCount') }}</span>
          <span class="num">{{ promotionStats.direct_valid_count || 0 }}</span>
        </div>
      </div>
    </div>

    <div class="invites">
      <div class="title">{{ $t('promotionCenter') }}</div>
      <div class="invite-content invite-code-row">
        <span class="link">{{ $t('promotionInviteCode') }}：{{ promotionInfo.invite_code || '-' }}</span>
        <span v-if="promotionInfo.invite_code" class="btn-copy kg-btn2" @click="onCopyCode">
          {{ $t('promotionCopy') }}
        </span>
      </div>
      <div class="invite-content">
        <span class="link">{{ inviteUrl || $t('promotionInviteDisabled') }}</span>
        <span v-if="inviteUrl" class="btn-copy kg-btn2" @click="onCopy">
          {{ $t('promotionCopyLink') }}
        </span>
        <span class="btn-copy kg-btn2 promotion-entry" @click="$router.push({ name: 'proxyPromotionCenter' })">
          {{ $t('promotionCenter') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      isloading: false,
      accountInfo: {},
      promotionInfo: {},
      promotionStats: {},
      inviteUrl: ''
    }
  },
  created () {
    this.getAccountInfo()
    this.getPromotionInfo()
  },
  methods: {
    getAccountInfo () {
      this.$http.get('/api/account/info').then(result => {
        this.accountInfo = result
      })
    },
    getPromotionInfo () {
      this.isloading = true
      this.$http.get('/api/promotion/info').then(result => {
        this.promotionInfo = result || {}
        this.promotionStats = this.promotionInfo.stats || {}
        this.inviteUrl = Number(this.promotionInfo.invite_enabled) === 1 && this.promotionInfo.invite_code
          ? `${window.location.protocol}//${window.location.host}/sign/sign-up?invite_code=${this.promotionInfo.invite_code}`
          : ''
      }).finally(() => {
        this.isloading = false
      })
    },
    onCopyCode () {
      if (!this.promotionInfo.invite_code) return
      this.$copyText(this.promotionInfo.invite_code).then(() => {
        this.$message.success(this.$t('promotionCopySuccess'))
      }).catch(() => {
        this.$message.error(this.$t('promotionCopyFailed'))
      })
    },
    onCopy () {
      this.$copyText(this.inviteUrl).then(e => {
        this.$alert(this.$t('public27'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
          }
        })
      }, function (e) {
      })
    },
    refresh () {
      this.isloading = true
      this.$store.dispatch('getUserInfo').then(result => {
        this.isloading = false
      }).catch(() => {
        this.isloading = false
      })
      this.getAccountInfo()
      this.getPromotionInfo()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
.page-home {
  background: url('../../../assets/img/index-bg.png') no-repeat bottom / 100% auto;
  background-attachment: fixed;
  min-height: 100vh;
  margin: 0 -38px;
  padding: 0 38px;

  .box-card-header {
    padding-top: 20px;
    display: flex;
    margin-bottom: 15px;
    justify-content: right;

    .right {
      display: flex;
      align-items: center;

      .btn {
        margin-left: 5px;
        color: #fff;

      }

      .refresh {
        margin-left: 5px;
      }
    }
  }

  .statistic-main {
    display: flex;
    justify-content: space-between;
    padding-right: 100px;
    padding-left: 50px;
    font-family: Arial-BoldMT;

    .statistic-wallet,
    .statistic-cash-account {
      width: 475px;
      height: 336px;
      position: relative;
      background: url('../../../assets/img/index/q.png') no-repeat center / 100% 100%;

      .title {
        position: absolute;
        z-index: 100;
        width: 200px;
        text-align: center;
        transform: rotateY(40deg);
        top: 0;
        color: #fff;
        font-size: 23px;
        top: 12px;
      }

      .name {
        position: absolute;
        z-index: 100;
        width: 475px;
        text-align: center;
        transform: rotateY(35deg);
        bottom: 120px;
        color: #fff;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .num {
        position: absolute;
        z-index: 100;
        width: 500px;
        text-align: center;
        transform: rotateY(35deg);
        bottom: 70px;
        left: 10px;
        color: #fff;
        font-size: 25px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 18px;
          margin-right: 10px;
        }
      }
    }

    .statistic-wallet {
      .title {
        transform: rotateY(40deg) rotate(1deg);
        left: 20px
      }

      .name {
        margin-left: 28px;
      }
    }

    .statistic-cash-account {

      background: url('../../../assets/img/index/s.png') no-repeat center / 100% 100%;

      .title {
        transform: rotateY(40deg) rotate(-1deg);
        left: auto;
        right: 30px;
        top: 18px;
      }

      .num {
        left: auto;
        right: 0px;
      }

    }
  }

  .btn-add-user {
    margin-top: 20px;
    margin-left: 40px;
    width: 150px;
    text-align: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 30px;
      height: 31px;
      left: 15px;
      top: 7px;
      background: url('../../../assets/img/+.png') no-repeat center / 100%;
    }
  }

  .statistic-item {
    width: 260px;
    height: 90px;
    margin-top: 20px;
    margin-left: 50px;
    background: url('../../../assets/img/icon_dl.png') no-repeat center / 100% auto;
    display: flex;

    .icon {
      width: 88px;
      height: 88px;
      flex: 0 0 88px;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-user,
      .icon-invite {
        width: 45px;
        height: 45px;
        display: block;
      }

      .icon-user {
        background: url('../../../assets/img/z1.png') no-repeat center / 100%;
      }

      .icon-invite {
        background: url('../../../assets/img/z2.png') no-repeat center / 100%;
      }
    }

    .statistic-item-info {
      flex: 1;

      .text {
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        display: block;
        text-align: center;
        padding-top: 15px;
      }

      .num {
        font-size: 28px;
        font-weight: 400;
        display: block;
        text-align: center;
        color: #00CBFA;
      }
    }
  }

  .invites {
    width: 670px;
    margin: 15px auto 0;
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 85px;
      height: 85px;
      left: -78px;
      bottom: -3px;
      position: absolute;
      background: url('../../../assets/img/icon-invite.png') no-repeat center / 100% auto;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #FFFFFF;
      padding-bottom: 10px;
      padding-left: 18px;
      border-bottom: 1px solid rgb(#BEF3FF, 0.3);
    }

    .invite-content {
      width: 670px;
      height: 34px;
      background: rgb(#000, 0.4);
      margin-top: 5px;
      position: relative;

      .link {
        font-size: 16px;
        font-family: Arial;
        font-weight: bold;
        color: #BEF3FF;
        line-height: 34px;
        padding-left: 15px;
      }

      .btn-copy {
        position: absolute;
        right: -8px;
        top: -8px;
        width: 100px;
      }

    }
  }
}

@media only screen and (max-width: 755px) {
  .page-home {
    background: url('../../../assets/img/index-bg.png') no-repeat bottom / 100% auto;
    background-attachment: fixed;
    min-height: 100vh;
    margin: 0 -38px;
    padding: 0 38px;

    .box-card-header {
      padding-top: 20px;
      display: flex;
      margin-bottom: 15px;
      justify-content: center;

      .right {
        display: flex;
        align-items: center;

        .btn {
          margin-left: 5px;
          color: #fff;

        }

        .refresh {
          margin-left: 5px;
        }
      }
    }

    .statistic-main {
      display: flex;
      justify-content: space-between;
      padding-right: 0;
      padding-left: 0;
      font-family: Arial-BoldMT;

      .statistic-wallet,
      .statistic-cash-account {
        width: 475px;
        height: 336px;
        position: relative;
        background: url('../../../assets/img/index/q.png') no-repeat center / 100% 100%;

        .title {
          position: absolute;
          z-index: 100;
          width: 200px;
          text-align: center;
          transform: rotateY(40deg);
          top: 0;
          color: #fff;
          font-size: 23px;
          top: 12px;
        }

        .name {
          position: absolute;
          z-index: 100;
          width: 325px;
          text-align: center;
          transform: rotateY(35deg);
          bottom: 120px;
          color: #fff;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .num {
          position: absolute;
          z-index: 100;
          width: 320px;
          text-align: center;
          transform: rotateY(35deg);
          bottom: 70px;
          left: 10px;
          color: #fff;
          font-size: 25px;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 18px;
            margin-right: 10px;
          }
        }
      }

      .statistic-wallet {
        margin-right: 10px;

        .title {
          transform: rotateY(40deg) rotate(1deg);
          left: 0;
        }

        .name {
          margin-left: 28px;
        }
      }

      .statistic-cash-account {
        margin-left: 10px;

        background: url('../../../assets/img/index/s.png') no-repeat center / 100% 100%;

        .title {
          transform: rotateY(40deg) rotate(-1deg);
          left: auto;
          right: 0;
          top: 18px;
        }

        .num {
          left: auto;
          right: 10px;
        }

      }
    }

    .btn-add-user {
      margin: 30px auto;
      width: 250px !important;
      text-align: center;
      position: relative;
      display: block;
      font-size: 18px;

      &::before {
        content: '';
        position: absolute;
        display: block;
        width: 30px;
        height: 31px;
        left: 30px;
        top: 15px;
        background: url('../../../assets/img/+.png') no-repeat center / 100%;
      }
    }

    .statistic-nums {
      display: flex;
      margin-top: 30px;
    }

    .statistic-item {
      width: 260px;
      height: 90px;
      margin-top: 0;
      margin-left: 0;
      background: url('../../../assets/img/icon_dl.png') no-repeat center / 100% auto;
      display: flex;

      .icon {
        width: 88px;
        height: 88px;
        flex: 0 0 88px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-user,
        .icon-invite {
          width: 45px;
          height: 45px;
          display: block;
        }

        .icon-user {
          background: url('../../../assets/img/z1.png') no-repeat center / 100%;
        }

        .icon-invite {
          background: url('../../../assets/img/z2.png') no-repeat center / 100%;
        }
      }

      .statistic-item-info {
        flex: 1;

        .text {
          font-size: 14px;
          font-weight: bold;
          color: #FFFFFF;
          display: block;
          text-align: center;
          padding-top: 15px;
        }

        .num {
          font-size: 28px;
          font-weight: 400;
          display: block;
          text-align: center;
          color: #00CBFA;
        }
      }
    }

    .invites {
      width: 670px;
      margin: 15px auto 0;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 85px;
        height: 85px;
        left: -78px;
        bottom: -3px;
        position: absolute;
        background: url('../../../assets/img/icon-invite.png') no-repeat center / 100% auto;
      }

      .title {
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        padding-bottom: 10px;
        padding-left: 18px;
        border-bottom: 1px solid rgb(#BEF3FF, 0.3);
      }

      .invite-content {
        width: 670px;
        height: 34px;
        background: rgb(#000, 0.4);
        margin-top: 5px;
        position: relative;

        .link {
          font-size: 16px;
          font-family: Arial;
          font-weight: bold;
          color: #BEF3FF;
          line-height: 34px;
          padding-left: 15px;
        }

        .btn-copy {
          position: absolute;
          right: -8px;
          top: -8px;
          width: 100px;
        }

      }
    }
  }

}
</style>
